<template>
  <div class="rentUserList">
    <div class="select">
       <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.phone" placeholder="用户电话" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllUser">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="693" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="手机号" align="center" prop="phone"></el-table-column>
        <el-table-column label="是否VIP" align="center" prop="isVip"></el-table-column>
        <el-table-column label="VIP时长" align="center" prop="vipTime"></el-table-column>
        <el-table-column label="订单数量" align="center" prop="orders"></el-table-column>
        <el-table-column label="订单总金额" align="center" prop="orderMoneys"></el-table-column>
        <el-table-column label="优惠总金额" align="center" prop="discountMoneys"></el-table-column>
        <el-table-column label="实付总金额" align="center" prop="realPays"></el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
  </div>
</template>

<script>
import {userList} from '../../api/usermanagement/usList.js'
export default {
  name: 'RentUserList',
  data() {
    return {
      request: {
        phone: '',
        current: '',
        size: ''
      },
      query: {current: 1, size: 20},
      response: {data: [], total: 0},
      loading: false,
    }
  },
  methods: {
    getAllUser(){
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      userList(this.request).then(result=>{
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      })
    },

    /**
     * 重置
     */
    reset(){
      this.request.phone = "";
      this.query.current = 1;
      this.getAllUser();
    },

    /**
     * 页码改变
     */
    currenChangeHandle(value){
      this.query.current = value;
      this.getAllUser();
    }
  },
  created(){
    this.getAllUser();
  }
}
</script>

<style scoped>
.rentUserList {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/usermanagement/rentuserlist.vue